module.exports = __webpack_public_path__ + "static/educators-bb1d78465748c721c9f9056ad6da4943.jpg";